module.exports = __webpack_public_path__ + "img/5.7c445f3e.webp";